import {ApiReturnObject} from '../types/global';

export const baseReturnObject: ApiReturnObject = {
    status: 0,
    success: false,
    error: null,
    response: null
};
